(function ($) {

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: true,
        });
        
        /* Magnific Popup - Default */
        $('.popup-modal').magnificPopup({
            type: 'inline',
            preloader: false,
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'right',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<span class="sidr__chat sidr__chat-left"></span>';
                sidrHtml += '<span class="sidr__chat sidr__chat-right"></span>';
                
                sidrHtml += '<div class="sidr__header">';
                sidrHtml += '<div class="sidr__logo">' + $('.site-logo').html() + '</div>';
                sidrHtml += '<span class="sidr__close" aria-label="Close Menu"></span>';
                sidrHtml += '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                if($('.site-header-subnav').length){
                    sidrHtml += '<div class="sidr__subnav">' + $('.site-header-subnav').html() + '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
            }
        });
        $('.menu-item').find('.arrow').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
        $('.back-button').click(function(){
            parent.history.back();
            return false;
        });

	});
    
    function checkOffset() {
        if($('#footer_modal').offset().top + $('#footer_modal').height() >= $('#colophon').offset().top){
            $('#footer_modal').css({
                'position' : 'absolute',
                'left' : 'auto',
                'right' : '0'
            });
        }
        if($(document).scrollTop() + window.innerHeight < $('#colophon').offset().top){
            $('#footer_modal').css({
                'position' : 'sticky',
                'left' : '100%',
                'right' : 'auto'
            });
        }
    }
    $(window).scroll(function() {
        checkOffset();
//        console.log('test');
    });



})(jQuery);